import type {
  AgentApiParams,
  ConnectionMetrics,
} from 'src/types/scheduler/global';
import type {SchedulerGlobalActions} from 'src/action-creators/scheduler/global';

import {
  SET_AGENT_API_PARAMS,
  SET_CONNECTION_METRICS,
} from 'src/action-creators/scheduler/global';


export type SchedulerGlobalState = {
  agentApiParams: AgentApiParams;
  connectionMetrics: ConnectionMetrics;
};

export const initialState: SchedulerGlobalState = {
  agentApiParams: {
    actor: 'self',
    agentId: '',
  },
  connectionMetrics: {
    maxConnections: -1,
    activeConnections: 0,
  },
};

export default function schedulerGlobal(
  state: SchedulerGlobalState = initialState,
  action: SchedulerGlobalActions,
): SchedulerGlobalState {
  switch (action.type) {
    case SET_AGENT_API_PARAMS:
      return {
        ...state,
        agentApiParams: action.payload,
      };
    case SET_CONNECTION_METRICS:
      return {
        ...state,
        connectionMetrics: action.payload,
      };
    default:
      return state;
  }
}
